import { render, staticRenderFns } from "./matrix1to5.vue?vue&type=template&id=61db2e2e"
import script from "./matrix1to5.vue?vue&type=script&lang=js"
export * from "./matrix1to5.vue?vue&type=script&lang=js"
import style0 from "./matrix1to5.vue?vue&type=style&index=0&id=61db2e2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports